define('formkit/behavior/template.object.reorder.drag.drop.behavior',['require','exports','module','underscore','./base.drag.drop.with.target.behavior'],function(require, exports, module) {
  var _                              = require('underscore');
  var BaseDragDropWithTargetBehavior = require('./base.drag.drop.with.target.behavior');

  var TemplateObjectReorderDragDropBehavior = BaseDragDropWithTargetBehavior.extend({
    defaults: _.extend({}, BaseDragDropWithTargetBehavior.prototype.defaults, {
      reorderOnly: true,
      onDrakeDrop: function(elView, targetView, sourceView, siblingView) {
        var form = targetView.form;
        if (form) {
          var newParent          = form.util.parent(targetView.collection);
          var siblingIndex       = siblingView? form.util.indexOfChild(newParent, siblingView.model):
                                                form.util.lastChildIndex(newParent) + 1;

          var currentIndex = form.util.indexOfChild(newParent, elView.model);

          var index = siblingIndex;

          // when child needs to move down, need to account for the fact
          // that sibling will move up by 1 and therefore it's index will decrease
          if (currentIndex < siblingIndex) {
            index = index - 1;
          }

          var templateObjectModel = elView.model;
          form.insertTemplateObject(newParent, templateObjectModel, index);
        }
      }
    })
  });
  module.exports = TemplateObjectReorderDragDropBehavior;
});

